import * as React from "react";
import styled from "styled-components";
import { useCarouselContext } from "../context";
const _CarouselProgressBar = ({ className, ...htmlProps }) => {
    const { state: { scrollProgress }, } = useCarouselContext("CarouselProgressBar");
    return (React.createElement("div", { className: className, ...htmlProps },
        React.createElement("div", { className: "rail" },
            React.createElement("div", { className: "indicator", style: { width: `${scrollProgress}%` } }))));
};
_CarouselProgressBar.defaultProps = {
    "data-testid": "progress-bar",
};
export const CarouselProgressBar = styled(_CarouselProgressBar) ``;
//# sourceMappingURL=CarouselProgressBar.js.map